// import {
//   Message
// } from 'element-ui'
//
//
// const resetMessage = (options) => {
//   if(resetMessage[options.type + 'Count'] === 0) {
//     resetMessage[options.type + 'Count'] ++
//     Message(options)
//     setTimeout(() => {
//       resetMessage[options.type + 'Count'] --
//     },options.duration || 3000)
//   }
// }
//
// ['error', 'success', 'info', 'warning'].forEach(type => {
//   resetMessage[type + 'Count'] = 0
//   resetMessage[type] = options => {
//     if (typeof options == 'string') {
//       options = {
//         message: options
//       }
//     }
//     options.type = type
//     return resetMessage(options)
//   }
// })
//
// export const message = resetMessage
import {
  Message
} from 'element-ui'

let messageInstance = null

const resetMessage = (options) => {
  if (messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
  return messageInstance
}

['error', 'success', 'info', 'warning'].forEach(type => {
  resetMessage[type] = options => {
    if (typeof options == 'string') {
      options = {
        message: options
      }
    }
    options.type = type
    return resetMessage(options)
  }
})

export const message = resetMessage
